<template>
  <div class="productDetail">
    <div class="detailTop">
      <div class="title">
        {{ info.title }}
        <span class="back" @click="goBack">&lt;&lt;&nbsp;返回</span>
      </div>
      <div class="line"></div>
      <div class="content">
        {{ info.introduction }}
      </div>
    </div>
    <div class="imgList">
      <div class="mainImg">
        <img :src="mainImg" alt="" />
      </div>
      <div class="tabs">
        <div class="leftArrow" @click="leftImg">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div class="imgContainer">
          <div class="imgs" :style="{ left: imgLeft + 'rem' }">
            <div class="imgItem" v-for="(item, index) in productImgs" :key="index" @click="chooseImg(item, index)">
              <div class="box"><img :src="item.filepath" alt="" /></div>
            </div>
          </div>
        </div>
        <div class="rightArrow" @click="rightImg">
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <div class="productInfo" v-html="info.content"></div>
  </div>
</template>

<script>
export default {
  name: "productDetail",
  props: ["id"],
  data() {
    return {
      imgLeft: 0,
      mainImg: "",
      imgInterval: "",
      info: [],
      imgLen: 0,
      imgIndex: 0,

      productImgs: [],
      articleinfo: [],
    };
  },
  created() {
    let id = this.$route.params.id - 1;
    /*this.info = this.productInfo[id];
    this.productImgs = this.productInfo[id].imgs;
    this.mainImg = this.productInfo[id].imgs[0];
    this.imgLen = this.productInfo[id].imgs.length;*/
    this.getarticleshow();
  },
  mounted() { },
  beforeDestroy() { },
  methods: {
      getarticleshow() {
          let self = this;
          var url = "index/article_show?article_id="+this.$route.params.id;
          self.$axios.get(self.api.apiurl + url).then(function (res) {
              //self.articleinfo = res.data.data.info.detail;
              self.info = res.data.data.info.detail;
              self.productImgs = res.data.data.info.slide_list;
              self.mainImg = res.data.data.info.slide_list[0].filepath;
              self.imgLen = res.data.data.info.slide_list.length;
          })
      },
    leftImg() {
      let index = this.imgIndex;
      if (index == 0) {
        return;
      } else if (index > 0) {
        this.mainImg = this.productImgs[index - 1].filepath;
        this.imgIndex = index - 1;
      }
    },
    rightImg() {
      let index = this.imgIndex;
      if (index == this.imgLen - 1) {
        return;
      } else if (index < this.imgLen - 1) {
        this.mainImg = this.productImgs[index + 1].filepath;
        this.imgIndex = index + 1;
      }
    },
    chooseImg(val, index) {
      this.mainImg = val.filepath;
      this.imgIndex = index;
    },
    move() {
      this.imgLeft = this.imgLeft - 18;
      if (this.imgLeft <= -54) {
        this.imgLeft = 0;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.productDetail {
  width: 120rem;
  margin: 0 auto;

    .el-icon-arrow-left:before {
        font-size: 2rem;
        font-weight: 800;
        color: black;
    }

    .el-icon-arrow-right:before {
        font-size: 2rem;
        font-weight: 800;
        color: black;
    }

  .detailTop {
    padding: 5rem 0;

    .title {
      text-align: center;
      font-size: 4.6rem;
      font-weight: 300;
      position: relative;

      .back {
        font-size: 1.6rem;
        color: #3d8bed;
        cursor: pointer;
        position: absolute;
        left: 1rem;
        top: 2rem;
      }
    }

    .line {
      width: 20rem;
      height: 0.4rem;
      background-color: #6366eb;
      margin: 2rem auto;
    }

    .content {
      text-align: left;
      font-size: 1.8rem;
      font-weight: 400;
      line-height: 1.8;
    }
  }

  .imgList {
    width: 100%;

    .mainImg {
      width: 100%;
      margin-bottom: 3rem;
      height: 48rem;
      overflow: hidden;

      img {
        /*width: 60%;
        margin-left: 20%;*/
        max-width: 100%;
      }
    }

    .tabs {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-evenly;

      .leftArrow {
        width: 6rem;
        cursor: pointer;
        padding-top: 7rem;
        margin-right: 1rem;
        transition: all 0.5s linear;
        text-align: center;
      }

      .leftArrow:hover {
        transition: 0.5s;
        background-color: #eee;
      }

      .imgContainer {
        height: 16rem;

        .imgs {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          transition: all 1s ease-in-out;

          .imgItem {
            width: 15rem;
            height: 15rem;
            padding: 0.5rem;
            background-color: #e3e8eb;
            border-radius: 0.5rem;
            margin-right: 2rem;
            cursor: pointer;

            .box {
              overflow: hidden;

              img {
                width: 15rem;
                height: 15rem;
                transition: all 0.8s ease;
              }

              img:hover {
                transition: 0.8s;
                transform: scale(1.1);
              }
            }
          }
        }
      }

      .rightArrow {
        width: 6rem;
        cursor: pointer;
        padding-top: 7rem;
        margin-left: 1rem;
        transition: all 0.5s linear;
        text-align: center;
      }

      .rightArrow:hover {
        transition: 0.5s;
        background-color: #eee;
      }
    }
  }

  .productInfo {
    .infoTitle {
      padding-left: 1rem;
      font-size: 3rem;
      font-weight: 500;
      border-left: 0.6rem solid #008ed3;
      text-align: left;
      height: 3.2rem;
      line-height: 3.2rem;
      margin: 4rem 0;
    }
    font-size: 2rem;

    .infoContent {
      font-size: 1.8rem;
      font-weight: 400;
      text-align: left;
      line-height: 1.8;
      margin-bottom: 4rem;
    }

    .infoContent1 {
      ul {
        margin: 0;
        padding: 0;
        margin-left: 2rem;
        margin-bottom: 4rem;

        li {
          text-align: left;
          font-size: 1.8rem;
          line-height: 1.8;

          .conTitle {
            font-weight: 600;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 750px) {
  .productDetail {
      width: 85%;
      margin: 0 auto;
    .detailTop{
      .title{
        font-size: 8.6rem;
      }
    }
    .imgList{
      .mainImg{
        height: 70rem;

        img{
          width: 80%;
          margin-left: 10%;
        }
      }
      .tabs {
        .leftArrow{
              padding-top: 5rem;
            }
        .imgContainer{
          height: 19rem;

          .imgItem {
            width: 17rem;
            height: 17rem;
          }

        }
        .rightArrow{
            padding-top: 5rem;
          }
      }
    }
    .productInfo{
      .infoTitle {
          padding-left: 3rem !important;
          font-size: 8rem !important;
          font-weight: 500;
          border-left: 2.2rem solid #008ed3 !important;
          text-align: left;
          height: 7.2rem !important;
          line-height: 6.2rem !important;
          margin: 4rem 0;
      }
      font-size: 8rem !important;
      p,span{font-size: 8rem !important;}
    }
  }
}
</style>
